import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SedsColorMode, SedsSizeOptions } from '../../shared/enums/index';
import { SedsColorModeType, SedsSizeOptionsType } from '../../shared/types';

@Component({
    selector: 'seds-avatar',
    templateUrl: './seds-avatar.component.html',
    styleUrls: ['./seds-avatar.component.scss'],
    standalone: false
})
export class SedsAvatarComponent implements OnChanges {
  @Input() avatarImage?: string;
  @Input() colorMode: SedsColorMode | SedsColorModeType = SedsColorMode.DEFAULT_LIGHT;
  @Input() size: SedsSizeOptions | SedsSizeOptionsType = SedsSizeOptions.STANDARD;
  @Input() text?: string;

  initials!: string;

  public getClassCssAvatar(): string {
    return `${this.colorMode} ${this.size}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text']) {
      this.setInitials();
    }
  }

  setInitials(): void {
    this.text = this.text || '';
    if (this.text !== '') {
      if (this.avatarImage) {
        console.warn('text cannot be used with avatarImage');
      } else {
        const fullNameArr = this.text.split(/\s/g);
        const secondLetter = fullNameArr.length >= 2 ? fullNameArr[fullNameArr.length - 1][0] : '';
        const initials = fullNameArr[0][0] + secondLetter;
        this.initials = initials.length === 2 ? initials : this.text;
        this.initials = this.initials.substring(0, 2).toUpperCase();
      }
    }
  }
}
